// deps
import React, { memo } from "react";

// internal deps
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";
import { isEmpty } from "@swiggy-private/core-ui";

// constants
import { TURBO_WALLET_BALANCE_TEXT } from "@payment-ui/constants/TurboPayment";

// styles
import { BalanceContentWrapper, BalanceValueContainer, Container, ContentWrapper } from "./styles";

interface ITurboPaymentDisplayNameProps {
    promoMsg?: string;
    newLineBalanceMeta?: {
        show: boolean;
        value?: string | number;
    };
    discount?: string;
    clampDiscountText?: boolean;
}

function TurboPaymentMethodMetaWidget(props: ITurboPaymentDisplayNameProps) {
    const { newLineBalanceMeta, discount, promoMsg, clampDiscountText = false } = props;
    return (
        <Container>
            {newLineBalanceMeta?.show && !isEmpty(newLineBalanceMeta.value) && (
                <BalanceContentWrapper>
                    <Text variant="V2.body3.neutral.regular" color="text_High_Emphasis">
                        {TURBO_WALLET_BALANCE_TEXT}
                    </Text>
                    <Text variant="V2.body3.neutral.regular" color="text_High_Emphasis">
                        <BalanceValueContainer>{String(newLineBalanceMeta.value)}</BalanceValueContainer>
                    </Text>
                </BalanceContentWrapper>
            )}
            {!isEmpty(discount) && (
                <ContentWrapper limitLines={clampDiscountText}>
                    <Text variant="V2.body3.neutral.medium" color="positive">
                        {discount}
                    </Text>
                </ContentWrapper>
            )}
            {promoMsg && promoMsg.length > 0 && (
                <ContentWrapper aria-hidden>
                    <Text variant="V2.body3.neutral.regular" color="text_Med_Emphasis">
                        {promoMsg}
                    </Text>
                </ContentWrapper>
            )}
        </Container>
    );
}

export default memo(TurboPaymentMethodMetaWidget);
